module.exports = __webpack_public_path__ + "img/feedback1.2b13edff.svg";